import {
  getCredentialsStore,
  getRulesStore,
  getDeviceAndUserStore,
} from '../storage/stores';

export const isFullyConfigured = () => {
  return (
    getCredentialsStore().get() !== undefined &&
    getRulesStore().get() !== undefined &&
    getDeviceAndUserStore().get() !== undefined
  );
};
